module.exports = __webpack_public_path__ + "img/microphone-lines.b33535f9.svg";